module.exports = __webpack_public_path__ + "img/sv33.78ba8569.png";